import { axiosClient } from "@/plugins/axios";

const DEFAULT_START_TIME = new Date(0, 0, 0).toISOString();
const DEFAULT_END_TIME = new Date().toISOString();

class Management {
  async fetchInstances() {
    const response = await axiosClient.get("/management/instances");
    return response.data;
  }

  async fetchPlans() {
    const response = await axiosClient.get("/management/plans");
    return response.data;
  }

  async fetchTenants() {
    const response = await axiosClient.get("/management/tenants");
    return response.data;
  }

  async fetchSubscriptions() {
    const response = await axiosClient.get("/management/subscriptions");
    return response.data;
  }

  async fetchLedger(
    start_time = DEFAULT_START_TIME,
    end_time = DEFAULT_END_TIME
  ) {
    try {
      const response = await axiosClient.get(
        `/management/ledger?start_time=${start_time}&end_time=${end_time}`
      );
      return response.data;
    } catch {
      return [];
    }
  }

  async fetchLedgerTimeSeries(
    frequency = "D",
    start_time = DEFAULT_START_TIME,
    end_time = DEFAULT_END_TIME
  ) {
    try {
      const response = await axiosClient.get(
        `/management/ledger/aggregate?interval=${frequency}&start_time=${start_time}&end_time=${end_time}`
      );
      return response.data;
    } catch {
      return {};
    }
  }

  async fetchLedgerCSV(
    start_time = DEFAULT_START_TIME,
    end_time = DEFAULT_END_TIME
  ) {
    const response = await axiosClient.get(
      `/management/ledger/csv?start_time=${start_time}&end_time=${end_time}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  }

  async fetchLedgerAggregateCSV(
    eventGroup,
    frequency,
    start_time = DEFAULT_START_TIME,
    end_time = DEFAULT_END_TIME
  ) {
    const response = await axiosClient.get(
      `/management/ledger/aggregate/csv?group=${eventGroup}&interval=${frequency}&start_time=${start_time}&end_time=${end_time}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  }

  async fetchInvoices(
    start_time = DEFAULT_START_TIME,
    end_time = DEFAULT_END_TIME
  ) {
    const response = await axiosClient.get(
      `/management/invoices?start_time=${start_time}&end_time=${end_time}`
    );
    return response.data;
  }

  async fetchQuotas() {
    const response = await axiosClient.get("/management/quotas");
    return response.data;
  }

  async fetchQuotaAggregate() {
    const response = await axiosClient.get("/management/quotas/aggregate");
    return response.data;
  }

  async fetchTenantQuotaAggregate(tenantUid) {
    const response = await axiosClient.get(
      `/management/quotas/aggregate/${tenantUid}`
    );
    return response.data;
  }
}

export default class GatewayAPI {
  constructor() {
    this.management = new Management();
  }

  setTenantUid(uid) {
    this.management.setTenantUid(uid);
  }
}
